<template>
  <div id="tab_charts" class="tab-pane fade in active">
    <div class="tab__header">Monthly Trending Charts</div>

    <div class="row">
      <div class="col-sm-12">
        <div class="basic-card benchmark-desc">
          The <span class="benchmark-low">Low</span>, <span class="benchmark-median">Median</span> and <span class="benchmark-high">High</span> benchmark lines on each chart represent benchmarks inside of Fuel practices. For the total practice, these lines are calculated by taking the individual provider benchmarks and multiplying them by the average # of providers inside of your practice. Click on the ‘Benchmarks’ tab above to see more about how your practice compares to these benchmarks.
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title">Hearing Test Trends</div>
          <HearingTestTrends></HearingTestTrends>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title">HAE/Opportunity Trends</div>
          <HaeOpportunityTrends></HaeOpportunityTrends>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title"># Patients Purchased Trends</div>
          <PatientsPurchasedTrends></PatientsPurchasedTrends>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title">Unit Trends</div>
          <UnitTrends></UnitTrends>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title">Net Revenue Trends</div>
          <NetRevenueTrends></NetRevenueTrends>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title">Net Margin Trends</div>
          <NetMarginTrends></NetMarginTrends>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title">Net Profit Trends</div>
          <NetProfitTrends></NetProfitTrends>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="basic-card">
          <div class="basic-card__card-title">Average Sale Price Trends</div>
          <AverageSalePriceTrends></AverageSalePriceTrends>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HearingTestTrends from './trending-charts/HearingTestTrends.vue';
  import HaeOpportunityTrends from './trending-charts/HaeOpportunityTrends.vue';
  import NetRevenueTrends from './trending-charts/NetRevenueTrends.vue';
  import NetMarginTrends from './trending-charts/NetMarginTrends.vue';
  import NetProfitTrends from './trending-charts/NetProfitTrends.vue';
  import PatientsPurchasedTrends from './trending-charts/PatientsPurchasedTrends.vue';
  import UnitTrends from './trending-charts/UnitTrends.vue';
  import AverageSalePriceTrends from './trending-charts/AverageSalePriceTrends.vue';

  export default {
    name: 'Charts',
    components: {
      UnitTrends,
      HearingTestTrends,
      HaeOpportunityTrends,
      NetRevenueTrends,
      NetMarginTrends,
      NetProfitTrends,
      PatientsPurchasedTrends,
      AverageSalePriceTrends,
    },
  };
</script>
